
(function () {
  var ua = navigator.userAgent;
  var b = 'Unknown';
  if (ua.indexOf('Firefox') > -1) b = 'Firefox';
  else if (ua.indexOf('Edg') > -1) b = 'Edge';
  else if (ua.indexOf('OPR') > -1 || ua.indexOf('Opera') > -1) b = 'Opera';
  else if (ua.indexOf('Chrome') > -1) b = 'Chrome';
  else if (ua.indexOf('Safari') > -1) b = 'Safari';
  if (document.body) document.body.setAttribute('browser', b);
})();

(function () {
  if (window.__z9Defer3pInit) return;
  window.__z9Defer3pInit = true;

  var SCROLL_FIRED = false;

  function releaseAll() {
    if (SCROLL_FIRED) return;
    SCROLL_FIRED = true;
    document.documentElement.classList.add('z9-3p-ready');
    window.removeEventListener('scroll', releaseAll);
    document.removeEventListener('keydown', releaseAll);
    document.removeEventListener('pointerdown', releaseAll);
  }

  
  window.addEventListener('scroll', releaseAll, { passive: true, once: true });
  document.addEventListener('keydown', releaseAll, { once: true });
  document.addEventListener('pointerdown', releaseAll, { once: true });

  
  setTimeout(releaseAll, 10000);

  
  if ('IntersectionObserver' in window) {
    var observed = false;
    function observeWhenReady() {
      if (observed) return;
      observed = true;
      var targets = document.querySelectorAll(
        '.jdgm-widget, .jdgm-rev-widg, .jdgm-carousel-wrapper, ' +
        '.instafeed-grid, [data-instafeed], .elfsight-app-instagram, #insta-feed'
      );
      if (!targets.length) return;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            releaseAll();
            io.disconnect();
            return;
          }
        }
      }, { rootMargin: '400px 0px' });
      targets.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeWhenReady);
    } else {
      observeWhenReady();
    }
  }
})();
